import React, { PropsWithChildren } from 'react';
import { useDrop } from 'react-dnd';
import { SavedReportDragItemType } from '../constants';

import styles from './saved-report-drop.scss';

interface SavedReportDropProps<T> {
  item: T;
  type: SavedReportDragItemType;
  updateItem: (item: T, sequence: number) => void;
}

export const SavedReportDrop = <T extends { sequence: number }>({
  item, type, updateItem, children
}: PropsWithChildren<SavedReportDropProps<T>>) => {

  const [{ isHover }, dropRef] = useDrop({
    accept: type,
    drop: (_, monitor) => {
      const dragItem = monitor.getItem() as T;
      if (dragItem?.sequence !== item?.sequence) {
        updateItem(dragItem, item?.sequence);
      }
    },
    collect: (monitor) => ({
      isHover: monitor.isOver({ shallow: true })
    })
  });

  return <div ref={(node) => {
    dropRef(node);
  }} className={isHover ? styles.tileHover : undefined}>
    {children}
  </div>;
};
